<template>
  <span>{{ getTime(text) }}</span>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { getTime } from '@/utils/function';
export default defineComponent({
  name: 'Cell_time',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: true,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
  setup() {
    return {
      getTime,
    };
  },
});
</script>
